<template>
  <vue-page-wraper :title="htmlTitle" :bread-crumbs="breadCrumbs">
    <v-card>
      <vue-card-title
        title="CRM Users"
        subtitle="Here you can see the list of CRM Users."
        :icon="$getIcon('mdiFileDocument')"
      >
        <template slot="actions">
          <v-btn
            class="mr-2 text-none"
            depressed
            small
            color="primary"
            @click="(displayForm = true), (actionData = {})"
          >
            Create User
          </v-btn>
          <v-btn icon @click="filter.show = !filter.show">
            <v-icon small v-text="$getIcon('mdiFilterVariant')"></v-icon>
          </v-btn>
        </template>
      </vue-card-title>
      <v-divider></v-divider>
      <v-slide-y-transition>
        <v-row v-show="filter.show" class="mx-1 py-0">
          <v-col>
            <v-text-field
              v-model="filter.search"
              label="Search"
              :append-icon="$getIcon('mdiMagnify')"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col>
          <v-select
            v-model="filter.is_active"
          :items="userStatus"
          :append-icon="$getIcon('mdiMagnify')"
          label="User Status"
        ></v-select>
          </v-col>
        </v-row>
      </v-slide-y-transition>
      <v-divider v-if="filter.show"></v-divider>
      <div>
        <div class="pa-3 caption blue-grey--text">
          <strong> Total Users: {{ response.count || 0 }}</strong>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="fetchedResults"
          :loading="loading"
          :sort-desc.sync="pagination.descending"
          :sort-by.sync="pagination.sortBy"
          :page.sync="pagination.page"
          :items-per-page.sync="pagination.rowsPerPage"
          :footer-props="footerProps"
          :server-items-length="pagination.totalItems"
          :mobile-breakpoint="0"
          must-sort
        >
          <template slot="item" slot-scope="props">
            <tr>
              <td class="text-left">
                <v-row align="center" no-gutters>
                  <v-avatar :size="35">
                    <v-img
                      :src="
                        $getProp(props.item, 'picture') ||
                          require(`@/static/images/info/user-default.png`)
                      "
                      alt="User avatar"
                    ></v-img>
                  </v-avatar>
                  <v-col class="text-left ml-2 font-weight-bold">
                    <div>
                      {{ fullName(props.item) }}
                    </div>
                  </v-col>
                </v-row>
              </td>
              <td>
                {{
                  (props.item.organization && props.item.organization.name) ||
                    "N/A"
                }}
              </td>
              <td>{{ props.item.gender || "N/A" }}</td>
              <td>{{ props.item.email || "N/A" }}</td>
              <td v-if="props.item.is_active">
                <span class="chip active">Active</span>
              </td>
              <td v-else="">
                <span class="chip inactive">InActive</span></td>
              <td class="text-center">
                <vue-context-menu
                  :context-list="[
                    {
                      name: 'Edit Details',
                      icon: 'mdiPencilOutline',
                      color: 'blue'
                    },
                    {
                      name: 'View Details',
                      icon: 'mdiEyeOutline',
                      color: 'blue'
                    }
                  ]"
                  @click0="(displayForm = true), (actionData = props.item)"
                  @click1="(showViewForm = true), (actionData = props.item)"
                ></vue-context-menu>
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <data-table-no-data :loading="loading"></data-table-no-data>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog
      v-if="displayForm"
      v-model="displayForm"
      scrollable
      persistent
      max-width="960px"
    >
      <create-form
        v-if="displayForm"
        :action-data="actionData"
        @close="displayForm = false"
        @create="(displayForm = false), loadDataTableChange()"
        @update="(displayForm = false), loadDataTableChange()"
      ></create-form>
    </v-dialog>
    <v-dialog
      v-if="showViewForm"
      v-model="showViewForm"
      scrollable
      persistent
      max-width="960px"
    >
      <view-form
        v-if="showViewForm"
        :action-data="actionData"
        @close="showViewForm = false"
      ></view-form>
    </v-dialog>
  </vue-page-wraper>
</template>
<script>
import DataTableMixin from "@/mixins/newDataTableMixin";
import DataTableNoData from "@/components/common/layout_utils/DataTableNoData";
import VueContextMenu from "@/components/common/layout_utils/VueContextMenu.vue";
import CreateForm from "@/components/crm/crm_user/forms/CreateCRMUser.vue";
import ViewForm from "@/components/crm/crm_user/forms/ViewCRMUserDetail.vue";
import VuePageWraper from "@/components/common/layout_utils/VuePageWrapper.vue";
export default {
  components: {
    VuePageWraper,
    CreateForm,
    ViewForm,
    DataTableNoData,
    VueContextMenu
  },
  mixins: [DataTableMixin],
  data() {
    return {
      loading: false,
      htmlTitle: "CRM Users",
      breadCrumbs: [{ text: "CRM Users", disabled: true }],
      displayForm: false,
      showViewForm: false,
      actionData: {},
      headers: [
        { text: "User", sortable: false },
        { text: "Organization", align: "", sortable: false },
        { text: "Gender", align: "", sortable: false },
        { text: "Email", align: "", sortable: false },
        { text: "Status", align: "", sortable: false },
        { text: "Action", align: "center", sortable: false }
      ],
      filter: {
        search: "",
        is_active: "",
        show: false
      },
      userStatus: ['Active','InActive',],
      endpoint: "/api/v1/users/"
    };
  },
  computed: {
    DataTableFilter() {
      return {
        search: this.filter.search,
        is_active: this.filter.is_active
      };
    }
  },
  created() {
    this.loadDataTableChange();
  },
  methods: {
    fullName(item) {
      return item.given_name
        ? `${item.given_name} ${item.middle_name} ${item.family_name}`
        : "N/A";
    },
    fetchDataTable() {
      this.loading = true;
      this.$axios
        .get(this.endpoint, {
          params: this.fullParams
        })
        .then(response => {
          this.loadDataTable(response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    humanizeDate(timeStamp) {
      if (timeStamp) return this.$dayjs(timeStamp).format("DD MMM YYYY");
      return "N/A";
    }
  }
};
</script>
